import React from 'react'
import { Block } from '../style'

export const PimBlock = ({ name, blockData }) => {
    return (
        <>
            {blockData.map((i, idx) => (
                <Block key={i.id || i.moduleId}>
                    <label>{name} {idx + 1}.</label> {i.name}
                </Block>
            ))}
        </>
    )
}
